export default __webpack_public_path__ + "static/loader-transparent-2643659202575456f0f3e0cc0804e19c.gif";